export default "__VITE_ASSET__BblPKbdY__"